import { ApiProperty } from "@nestjs/swagger";
import { IsNotEmpty } from "class-validator";

export class VPLActivateOrDeActiveRequest{
    @ApiProperty()
    @IsNotEmpty()
    vendorPriceListId: number;
    @ApiProperty()
    isActive: boolean;
    @ApiProperty()
    versionFlag?:number;
    @ApiProperty()
    updatedUser?:string;
    constructor(vendorPriceListId: number, isActive: boolean, versionFlag?:number, updatedUser?:string){
        this.vendorPriceListId = vendorPriceListId;
        this.isActive = isActive;
        this.versionFlag = versionFlag;
        this.updatedUser = updatedUser;
    }
}